// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__QWbEP","row":"ProcedureTreatmentSummary_row__1oqou"};